import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { OperationShiftService } from '../../services/operation-shift.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Department, Machine } from 'src/app/modules/shared/interface/department.entity';
import { DepartmentService } from 'src/app/modules/shared/services/department.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { catchError, interval, of, Subscription, tap } from 'rxjs';
import { MachineMonthlyOutputDTO } from '../../interfaces/operator-output.entity';
import { OperatorWeeklyOutputDTO } from '../../interfaces/operator-output.entity';



@Component({
  selector: 'app-operator-output',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './operator-output.component.html',
  styleUrl: './operator-output.component.scss'
})
export class OperatorOutputComponent implements OnInit, OnDestroy {

  operationShiftService = inject(OperationShiftService);
  departmentService = inject(DepartmentService);
  loading = inject(LoadingService);
  notification = inject(NotificationService);

   protected MachineSearchParams = signal({
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          machine: 2
      });

    protected $$departmentDTO = signal<Department[]>([]);
    protected $$availableMachines = signal<Machine[]>([]);
    protected $$machineMonthlyOutputDTO = signal<MachineMonthlyOutputDTO[]>([]);

    departmentId: number | null = null;
    machineId: number | null = null;
    Year = signal(new Date().getFullYear());
    Month = signal(new Date().getMonth());
    selectedYear: number = this.Year();
    selectedMonth: number = this.Month();
    months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    years: number[] = [];

    weekKeys: Array<keyof OperatorWeeklyOutputDTO> = ['week1', 'week2', 'week3', 'week4'];
    animated = false;
    currentTime: string = '';
    showFilters: boolean = false;

    private clockSub?: Subscription;
    public Math = Math;


    constructor() {
      this.fetchDepartment();
      this.populateYears();
      this.getOutPutData()
    }

    ngOnInit(): void {
      this.clockSub = interval(1000).subscribe(() => {
        this.currentTime = new Date().toLocaleTimeString();
      });

      interval(30 * 60 * 1000).subscribe(() => {
      this.getOutPutData();
    });
    }

  ngOnDestroy(): void {
    this.clockSub?.unsubscribe();
  }

  onDepartmentChange(departmentId: number): void {
    this.departmentId = departmentId;

    const selectedDepartment = this.$$departmentDTO().find(
      dept => dept.departmentId === departmentId
    );

    if (selectedDepartment) {
      this.$$availableMachines.set(selectedDepartment.machines || []);
      this.machineId = null; 
    } else {
      this.$$availableMachines.set([]);
      this.machineId = null;
    }
  }


    public fetchDepartment(): void {
        this.departmentService.getAllDepartments().subscribe({
            next: (result) => {
                if (result.data && result.data.departments) {
                    this.$$departmentDTO.set(result.data.departments);
                    this.$$availableMachines.set(result.data.departments[0].machines);
                    this.departmentId = result.data.departments[0]?.departmentId ?? null;
                    // console.log(this.$$availableMachines());
                }
            },
            error: (error) => {
                console.error('Error fetching departments:', error);
                this.notification.set({ type: 'error', message: 'Failed to fetch departments' });
            }
        });
    }

    populateYears(): void {
        const startYear = 2025;
        this.years = Array.from({ length: 11 }, (_, i) => startYear + i);
    }

     getOutPutData() {
            this.loading.set(true);
            this.operationShiftService.getShiftOutputByMachine(this.MachineSearchParams()).pipe(
                tap(response => {
                    this.loading.set(false);
                    this.$$machineMonthlyOutputDTO.set([response.data]);
                    setTimeout(() => {
                      this.animated = true;
                    }, 1000);
                }),
                
                catchError(error => {
                    this.loading.set(false);
                    this.notification.set({ type: 'error', message: `Failed to fetch shift Output data` });
                    console.error(error);
                    return of(null);
                })
            ).subscribe();
        }

      onMachineChange(machineId: number): void {
        this.MachineSearchParams.update(params => ({
            ...params,
            machine: machineId
        }));
        this.getOutPutData();
      }

       updateCalendarYear(year: number): void {
        this.MachineSearchParams.update(params => ({
            ...params,
            year: year
        }));
        this.getOutPutData();
    }

    updateCalendarMonth(month: number): void {
        const newMonth = +month + 1;
        this.MachineSearchParams.update(params => ({
            ...params,
            month: newMonth
        }));
        this.getOutPutData();
      }

      get maxOutput(): number {
        const all = this.$$machineMonthlyOutputDTO()[0]?.data || [];
        let maxVal = 0;
        all.forEach(op => {
          maxVal = Math.max(maxVal, op.week1, op.week2, op.week3, op.week4, op.total_output);
        });
        return maxVal || 1; 
      }

      getAnimatedWidth(value: number): string {
        if (!this.maxOutput) return '0%';
        const percentage = (value / this.maxOutput) * 100;
        return percentage + '%';
      }


}
